'use strict';
import {combineReducers} from 'redux';
import {SERVER_STATUS_STATE, TRACK_LOCATION_NAME} from '../actions';
import {serverStatus} from './serverStatusReducers';
import {trackLocation} from './trackLocationReducers';

export * from './state';

export const settings = combineReducers({
  [SERVER_STATUS_STATE]: serverStatus,
  [TRACK_LOCATION_NAME]: trackLocation,
});

export const storageWhitelist = [
  ['settings', TRACK_LOCATION_NAME],
];



// WEBPACK FOOTER //
// ./src/js/settings/reducers/index.js